function init() {
  const form = document.getElementById('site-search')
  if (!form) {
    return
  }
  document
    .getElementById('search-submit')
    .addEventListener('click', function () {
      form.submit()
    })
}

export default init
